import React, { useEffect, useState, useContext } from 'react'
import moment from 'moment'

import {
  getListDeliveryCreatedByHost,
  callNewDeliveryCreatedByHost,
  getScheduledDelivery,
} from '_redux/modules/delivery'
import { getMyGroups } from '_redux/modules/group'
import deliveryApi from '_api/delivery'
import { useDispatch, useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import { convertToCurrentGMT, convertToGMT0, convertTimeStringWithDuration } from '_utils/function'
import { GROUP_IS_HOST, DEFAULT_DELIVERY_OPTION, LIST_TIME } from '_utils/constant'
import { getUserInfo } from '_utils/localData'

import WithErrorBoundary from '_components/WithErrorBoundary'

import './style.scss'
import DeliveryOptionsModal from '../../../pages/Event/components/DeliveryOptionsModal'
import BoxDeliveryDateByHost from '../../../pages/Event/components/BoxDeliveryDateByHost'
import { SelectIdGroupContext } from '../../../context/SelectGroupContext'
import MyScheduledDelivery from '../../../pages/Event/components/MyScheduleDelivery'

const now = moment().unix()

const SpinnerLoading = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      marginTop: '20%',
    }}
  >
    <div
      className='spinner-border text-info'
      style={{ display: 'flex', justifyContent: 'center' }}
      role='status'
    >
      <span className='sr-only'>Loading...</span>
    </div>
  </div>
)

const DeliveryList = () => {
  const { infoGroupSelected } = useContext(SelectIdGroupContext)
  const dispatch = useDispatch()
  const { addToast } = useToasts()

  const userInfo = getUserInfo()
  const { id: userId } = userInfo
  const { listDeliveryCreatedByHost, allScheduleDelivery } = useSelector((state) => state.delivery)

  let { listDeliveryCreated = null } =
    listDeliveryCreatedByHost.find((item) => item.hostId === userId) || {}

  listDeliveryCreated = listDeliveryCreated
    ? listDeliveryCreated.sort((a, b) => a.deliveryTimestamp - b.deliveryTimestamp)
    : null

  const { listScheduleDelivery = null } =
    allScheduleDelivery.find((item) => item.hostId === userId) || {}

  const { myGroups } = useSelector((state) => state.group)
  const [isLoading, setIsLoading] = useState(false)
  const [openModalAddDelivery, setOpenModalAddDelivery] = useState(false)
  const [timeReRender, setTimeReRender] = useState(0)

  const [isSubmitting, setIsSubmitting] = useState(false)

  const [deliveryZones, setDeliveryZones] = useState([])

  const [deliveryHourStart, setDeliveryHourStart] = useState('10AM')
  const [deliveryHourEnd, setDeliveryHourEnd] = useState('1PM')
  const [timeGetScheduleDelivery, setTimeGetScheduleDelivery] = useState(0)

  const toggleModalAddDelivery = () => {
    setOpenModalAddDelivery(!openModalAddDelivery)
  }

  useEffect(() => {
    const getEvents = async () => {
      setIsLoading(true)
      try {
        await dispatch(getMyGroups)
        await dispatch(getScheduledDelivery(userId))
        await dispatch(getListDeliveryCreatedByHost(userId))
      } catch (error) {
        addToast(error?.message, { appearance: 'error', autoDismiss: true })
      }
      setIsLoading(false)
    }

    getEvents()
  }, [infoGroupSelected])

  const [optionGroup, setOptionGroup] = useState([])
  const [selectedGroup, setSelectedGroup] = useState('')

  const [deliveryTime, setDeliveryTime] = useState(
    new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
  )

  useEffect(() => {
    if (myGroups && myGroups.length) {
      const hostForGroup = myGroups?.filter((group) => group.isHost === GROUP_IS_HOST)
      setOptionGroup([...hostForGroup])
      setSelectedGroup(hostForGroup[0]?.gid || hostForGroup[0]?.id)
    }
  }, [myGroups])

  useEffect(() => {
    dispatch(getListDeliveryCreatedByHost(userId))
  }, [timeReRender])

  const handleOnClickOk = async () => {
    setIsSubmitting(true)
    const deliveryStartIndex = LIST_TIME.findIndex((item) => item.text === deliveryHourStart)
    const deliveryEndIndex = LIST_TIME.findIndex((item) => item.text === deliveryHourEnd)
    const timeStart = LIST_TIME[deliveryStartIndex].value
    const timeEnd = LIST_TIME[deliveryEndIndex].value
    const deliveryDuration = (timeEnd - timeStart) * 3600
    if (deliveryDuration < 0) {
      addToast('Invalid delivery time duration', { appearance: 'error', autoDismiss: true })
      setIsSubmitting(false)
      return
    }

    const rememberedDeliveryZones = deliveryZones
      .map(({ name, price }) => ({ name, price }))
      .filter((item) => item.name && item.price >= 0)

    const deliveryTimeLocal = `${moment(deliveryTime).format('DD-MM-YYYY')} ${timeStart}:00`

    const deliveryTimestamp = moment(deliveryTimeLocal, 'DD-MM-YYYY HH:mm').unix()

    if (deliveryTimestamp < now) {
      setIsSubmitting(false)
      addToast('Delivery time must after current time', { appearance: 'error', autoDismiss: true })
      return
    }

    const deliveryTimeGMT0 = convertToGMT0(deliveryTimeLocal)

    try {
      await deliveryApi.createDeliveryByHost({
        groupId: selectedGroup,
        deliveryTime: deliveryTimeGMT0,
        deliveryDuration,
      })

      dispatch(callNewDeliveryCreatedByHost())
      setTimeReRender((prevState) => prevState + 1)

      await deliveryApi.updateRememberedDeliveryZones(userId, {
        rememberedDeliveryZones,
      })
      addToast('Added delivery', { appearance: 'success', autoDismiss: true })
    } catch (error) {
      setIsSubmitting(false)
      addToast(error?.msgResp, { appearance: 'error', autoDismiss: true })
      return
    }
    setIsSubmitting(false)
    toggleModalAddDelivery()
  }

  const onChangeTimeDelivery = (e) => {
    setDeliveryTime(e)
  }

  const onChangeZoneDelivery = (index, type, value) => {
    deliveryZones[index][type] = value
    setDeliveryZones([...deliveryZones])
  }

  const handleAddMoreDeliveryZone = () => {
    setDeliveryZones(JSON.parse(JSON.stringify([...deliveryZones, DEFAULT_DELIVERY_OPTION])))
  }

  const handleOnRemoveDeliveryZone = (index) => {
    deliveryZones.splice(index, 1)
    setDeliveryZones(JSON.parse(JSON.stringify([...deliveryZones])))
  }

  const onOpenAddDelivery = async () => {
    const { msgResp } = await deliveryApi.getRememberedDeliveryZones()
    if (msgResp.length > 0) {
      setDeliveryZones(msgResp)
    } else {
      setDeliveryZones(JSON.parse(JSON.stringify([...deliveryZones, DEFAULT_DELIVERY_OPTION])))
    }
    toggleModalAddDelivery()
  }

  useEffect(() => {
    dispatch(getScheduledDelivery(userId))
  }, [timeGetScheduleDelivery])

  return (
    <div className='row-top my-events-page'>
      {isLoading && <SpinnerLoading />}
      {!isLoading ? (
        <>
          <div className='hosted__event-list-desktop size-width-desktop-col-2'>
            <h3 className='hosted__event-list-desktop-title'>Manage Delivery</h3>
            <div
              style={{ width: '100px', marginLeft: '89%' }}
              className='text-add-delivery d-flex flex-row-reverse mt-2 mb-2'
              onClick={onOpenAddDelivery}
            >
              Add delivery
            </div>
            <div className='hosted__event-list-desktop-item-grid'>
              {listDeliveryCreated && listDeliveryCreated.length
                ? listDeliveryCreated
                    .filter((ele) => ele.deliveryTimestamp >= now)
                    .map((item, idex) => (
                      <BoxDeliveryDateByHost
                        key={idex}
                        createdUserPhotoUrl={item.createdUserPhotoUrl}
                        createdUserName={item.createdUserName}
                        groupName={item.groupName}
                        deliveryTimeString={convertTimeStringWithDuration(
                          item.deliveryTime,
                          item.deliveryDuration
                        )}
                        deliveryTime={convertToCurrentGMT(item.deliveryTime)}
                        deliveryId={item.id}
                      />
                    ))
                : null}

              {listDeliveryCreated && listDeliveryCreated.length
                ? listDeliveryCreated
                    .filter((ele) => ele.deliveryTimestamp < now)
                    .map((item, idex) => (
                      <BoxDeliveryDateByHost
                        key={idex}
                        createdUserPhotoUrl={item.createdUserPhotoUrl}
                        createdUserName={item.createdUserName}
                        groupName={item.groupName}
                        deliveryTimeString={convertTimeStringWithDuration(
                          item.deliveryTime,
                          item.deliveryDuration
                        )}
                        deliveryTime={convertToCurrentGMT(item.deliveryTime)}
                        deliveryId={item.id}
                        greyOut={true}
                      />
                    ))
                : null}

              {listScheduleDelivery?.map((delivery, index) => (
                <MyScheduledDelivery
                  key={index}
                  delivery={delivery}
                  hostId={userId}
                  setTimeGetScheduleDelivery={setTimeGetScheduleDelivery}
                />
              ))}
            </div>

            {listDeliveryCreated?.length === 0 && !isLoading && (
              <div>You dont have any delivery!!!</div>
            )}

            {openModalAddDelivery && (
              <DeliveryOptionsModal
                modal={openModalAddDelivery}
                toggle={toggleModalAddDelivery}
                handleOnClickOk={handleOnClickOk}
                deliveryZones={deliveryZones}
                deliveryTime={deliveryTime}
                onChangeZoneDelivery={onChangeZoneDelivery}
                onChangeTimeDelivery={onChangeTimeDelivery}
                handleAddMoreDeliveryZone={handleAddMoreDeliveryZone}
                handleOnRemoveDeliveryZone={handleOnRemoveDeliveryZone}
                deliveryHourStart={deliveryHourStart}
                setDeliveryHourStart={setDeliveryHourStart}
                deliveryHourEnd={deliveryHourEnd}
                setDeliveryHourEnd={setDeliveryHourEnd}
                selectedGroup={selectedGroup}
                setSelectedGroup={setSelectedGroup}
                optionGroup={optionGroup}
                isSubmitting={isSubmitting}
              />
            )}
          </div>
        </>
      ) : null}
    </div>
  )
}

export default WithErrorBoundary(DeliveryList)
